/**
 * 교사 태그 팔레트(SR-MDF-05 · FS-11-07) — 원리 태그는 @picnic-field/mdf PRINCIPLE_TAGS 안에서만(계약 PATCH …/works teacherTags).
 * mdf 패키지(컴파일러 · 커널 의존)를 셸 번들에 끌어오지 않으려고 값을 옮겨 두고, 같은지는 단위 시험이 지킨다(tags.test.ts).
 */
export const PRINCIPLE_TAGS = [
  "gear-ratio",
  "crank-rocker",
  "crank-slider",
  "rack",
  "five-bar",
  "linkage",
] as const;

export type PrincipleTag = (typeof PRINCIPLE_TAGS)[number];

export const isPrincipleTag = (t: string): t is PrincipleTag =>
  (PRINCIPLE_TAGS as readonly string[]).includes(t);

/** 태그 목록이 같은지(순서 무관) */
export function sameTags(a: readonly string[], b: readonly string[]): boolean {
  const x = [...new Set(a)].sort();
  const y = [...new Set(b)].sort();
  return x.length === y.length && x.every((v, i) => v === y[i]);
}

/** 태그 한 개 넣고 빼기 — 팔레트 순서로 정리 */
export function toggleTag(tags: readonly string[], tag: string): string[] {
  const next = tags.includes(tag) ? tags.filter((t) => t !== tag) : [...tags, tag];
  const order = (t: string) => {
    const i = (PRINCIPLE_TAGS as readonly string[]).indexOf(t);
    return i < 0 ? 99 : i;
  };
  return [...new Set(next)].sort((a, b) => order(a) - order(b));
}
